import React from 'react';
import { FadeIn } from './FadeIn';
import { X } from 'lucide-react';
export function FailedAttemptsSection() {
  const attempts = ['Screen-time limits create resentment rather than teaching productivity or responsibility.', 'Traditional "entry-level" jobs offer zero creative outlet and pay the absolute bare minimum.', '"Influencer" dreams feel out of reach because the competition is too high for a global audience.', 'Online "surveys" and generic "side hustles" are often low-pay traps that don\'t build a real resume.'];
  return <section className="bg-brand-cream py-20 px-6" data-id="element-63">
      <div className="max-w-3xl mx-auto" data-id="element-64">
        <FadeIn data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center" data-id="element-66">
            Why What You Tried Didn't Work
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-67">
          {attempts.map((attempt, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-68">
              <div className="flex items-start bg-white p-6 rounded-xl shadow-sm border border-brand-navy/5" data-id="element-69">
                <div className="flex-shrink-0 mt-1" data-id="element-70">
                  <div className="bg-red-100 p-1.5 rounded-full" data-id="element-71">
                    <X className="w-5 h-5 text-red-500" data-id="element-72" />
                  </div>
                </div>
                <p className="ml-4 text-lg text-brand-gray leading-relaxed" data-id="element-73">
                  {attempt}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}